import React from "react";
import { ManageProductVariant } from "../../components/ProductManager/productVariants/ManageProductVariant";
import { ToastContainer } from "react-toastify";
export const ManageProductVariantPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageProductVariant />
        </div>
      </div>
    </div>
  );
};
